var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"chain",class:{
            completed: item.completed || item.skiped,
            active: item.active,
            clickable: _vm.isClickable(item),
            editing: !item.completed && item.active,
            gray: item.tag === 'customer-cadastrado'
        }},[_c('div',{staticClass:"circle",on:{"click":function($event){_vm.activeThis(item, _vm.isClickable(item))}}},[_vm._m(0,true)]),_c('div',{class:{ clickable: _vm.isClickable(item) },on:{"click":function($event){_vm.activeThis(item, _vm.isClickable(item))}}},[_c('h3',{staticClass:"title",class:{ completed: item.completed || item.skiped }},[_vm._v(" "+_vm._s(item.name)+" ")])])])}),0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status"},[_c('em',{staticClass:"fal fa-check icon"})])
}]

export { render, staticRenderFns }